import { Input as InputComponent, InputRoot, InputIcon } from "./Input";

export { InputRoot, InputIcon };
export const Input = InputComponent;

export * from "./types";
